export const AUTHENTICATION_DATA_KEY = 'auth';
